// extracted by mini-css-extract-plugin
module.exports = {"btn":"style_btn__1ilK0","row":"style_row__1lkvo","title":"style_title__1xS0G","outlined":"style_outlined__1-oTf"};